import Anchor from '@totallymoney/ui/components/Anchor'
import Modal from '@totallymoney/ui/components/Modal'
import Stack from '@totallymoney/ui/components/Stack'
import Text from '@totallymoney/ui/components/Text'

const LittleLoansModal = ({
    showModal,
    onModalClose,
}: {
    onModalClose: () => void
    showModal: boolean
}) => (
    <Modal
        title="About Little Loans"
        hasHeader={true}
        isOpen={showModal}
        onClose={onModalClose}
        isFullScreen={true}
    >
        <Stack space="space15">
            <Text>
                Digitonomy Limited, trading as Little-Loans, is a credit broker,
                not a lender. If you click &quot;Get my personalised
                quote&quot;, you will be redirected to our partner Digitonomy
                Ltd.
            </Text>
            <Text>
                For information about how Digitonomy Ltd may use your data,
                please read their{' '}
                <Anchor
                    href="https://www.little-loans.com/privacy-policy"
                    target="_blank"
                    rel="noopener"
                    aria-label="Opens in a new tab to Little Loans privacy policy"
                >
                    privacy policy
                </Anchor>
                .
            </Text>
            <Text>
                *If you are approved for a loan using this credit broker
                service, your loan could be sent to your bank within minutes.
            </Text>
            <Text>
                The time that it takes for the money to be received in your
                account will depend on the lender you are accepted by and your
                bank&apos;s policies and procedures.
            </Text>
        </Stack>
    </Modal>
)

export default LittleLoansModal
